import { url, sourceStr, inviteSource, setTip, bi } from './gb'
import Scene from './scene'
import { Role, userInfo } from './role'
import Friend from './friend'
import Lottery from './lottery'

let loginSuccessResolve = null

const Login = {
  api_login: () => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.logState,
        data: {
          inviteCode: inviteSource,
          source: sourceStr
        },
        dataType: 'jsonp'
      }).done(function(d) {
        if (d.success) {
          Login.UI_logined()
          resolve()
        } else {
          reject(d.messages)
          setTip(d.messages)
        }
      })
    })
  },
  api_logout: () => {
    $.ajax({
      url: url.logout,
      dataType: 'jsonp'
    }).done(function(d) {
      if (d.success) {
        Login.UI_logout()
      } else {
        setTip(d.messages)
      }
    })
  },
  checkLogin: () => {
    if (!TlPassport.isLoggedIn()) {
      TlPassport.show()
      return new Promise(resolve => {
        loginSuccessResolve = resolve
      })
    }
  },
  UI_logined: async () => {
    Login.UI_resetLotteryItem()
    $('[data-logout]').hide()
    $('[data-logined]').show()
    $('[data-username]')
      .text(TlPassport.data('username'))
      .attr('title', TlPassport.data('username'))

    await Role.api_getRoleList()
    await Role.api_getUserInfo()
    Lottery.UI_lotterySurplus(userInfo.surplus)

    await Scene.api_sceneInit()

    loginSuccessResolve && loginSuccessResolve()

    // UI渲染放下面
    Friend.UI_friendInit()
    Scene.UI_sceneStatusInit()
  },
  UI_logout: () => {
    $('[data-logined]').hide()
    $('[data-logout]').show()
    $('[data-username]')
      .text('')
      .attr('title', '')
    $('[data-btn-bind-dialog]').text('【绑定角色】')
    Scene.UI_sceneReset()
    Friend.UI_friendReset()
    Lottery.UI_lotterySurplus(0)
    Login.UI_resetLotteryItem()
  },
  UI_resetLotteryItem: () => {
    if ($('[data-lottery-gift] .active').length > 0) {
      $('[data-lottery-gift] .active').removeClass('active')
    }
  }
}

$('[data-btn-logout]').on('click', () => {
  TlPassport.logout(success => {
    if (success) {
      Login.api_logout()
    }
  })
  bi('链接-退出')
})

$('[data-btn-login]').on('click', () => {
  TlPassport.show()
  bi('链接-登录')
})

TlPassport.on('loginSuccess', async () => {
  await Login.api_login()
})
TlPassport.on('registerSuccess', async () => {
  await Login.api_login()
})

export default Login
